import reportService from '@/api/report'

import { EMPLOYEE_GROUPS, REPORT } from '../types'
import utils from '@/utils/utils'
import Vue from 'vue'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    dateStart: '',
    dateEnd: '',
    employeeGroup: [],
    deskGroup: [],
    location: [],
    restaurant: [],
    itinerary: [],
    site: [],
    individualDesks: [],
    parking: [],
    bookingStatus: null,
    employeeGroups: [],
    deskGroups: [],
    itineraries: [],
    restrictionName: null,
    parkings: [],
    locations: [],
    owners: [],
    usedBy: [],
    sitesWithRestaurants: null,
    sitesWithLocations: null,
    sitesWithParkings: null,
    lockerReports: [],
    restrictionReports: [],
    isDownloadingFile: false,
    reportType: '',
    unbookedEntranceType: null,
    unbookedEntranceReports: [],
  },

  getters:{
    bookingStatus: (state) => {
      return state.bookingStatus
    },
    employeeGroup: (state) => {
      return state.employeeGroup
    },
    deskGroup: (state) => {
      return state.deskGroup
    },
    site: (state) => {
      return state.site
    },
    individualDesks: (state) => {
      return state.individualDesks
    },
    location: (state) => {
      return state.location
    },
    restaurant: (state) => {
      return state.restaurant
    },
    itinerary: (state) => {
      return state.itinerary
    },
    restrictionName: (state) => {
      return state.restrictionName
    },
    parking: (state) => {
      return state.parking
    },
    itineraries: (state) => {
      return state.itineraries
    },
    startDate: (state) => {
      return state.dateStart
    },
    endDate: (state) => {
      return state.dateEnd
    },
    restrictionReports: (state) => {
      return state.restrictionReports
    },
    reportType: (state) => {
      return state.reportType
    },
    unbookedEntranceType: (state) => {
      return state.unbookedEntranceType
    },
    unbookedEntranceReports: (state) => {
      return state.unbookedEntranceReports
    }
  },

  mutations: {
    [REPORT.SET_STARTDATE](state, val) {
      state.dateStart = val
    },
    [REPORT.SET_ENDDATE](state, val) {
      state.dateEnd = val
    },
    [REPORT.SET_EMPLOYEEGROUPS](state, val) {
      state.employeeGroups = val
    },
    [REPORT.SET_DESKGROUPS](state, val) {
      state.deskGroups = val
    },
    [REPORT.SET_PARKINGS](state, val) {
      state.parkings = val
    },
    [REPORT.SELECT_ITINERARIES](state, val) {
      state.itineraries = val
    },
    [REPORT.SET_SITES_WITH_LOCATIONS](state, val) {
      state.sitesWithLocations = val
    },
    [REPORT.SET_SITES_WITH_RESTAURANTS](state, val) {
      state.sitesWithRestaurants = val
    },
    [REPORT.SET_SITES_WITH_PARKINGS](state, val) {
      state.sitesWithParkings = val
    },
    [REPORT.SELECT_EMPLOYEEGROUP](state, val) {
      state.employeeGroup = val
    },
    [REPORT.SELECT_DESKGROUP](state, val) {
      state.deskGroup = val
    },
    [REPORT.SELECT_LOCATION](state, val) {
      state.location = val
    },
    [REPORT.SELECT_RESTAURANT](state, val) {
      state.restaurant = val
    },
    [REPORT.SELECT_ITINERARY](state, val) {
      state.itinerary = val
    },
    [REPORT.SELECT_RESTRICTION_NAME](state, val) {
      state.restrictionName = val
    },
    [REPORT.SELECT_SITE](state, val) {
      state.site = val
    },
    [REPORT.SELECT_SINGLE_DESK](state, val) {
      state.individualDesks.push(val)
    },
    [REPORT.SELECT_PARKING](state, val) {
      state.parking = val
    },
    [REPORT.SELECT_BOOKINGSTATUS] (state, val) {
      state.bookingStatus = val
    },
    [REPORT.SELECT_OWNER] (state, val) {
      state.owners.push(val)
    },
    [REPORT.CLEAR_OWNER] (state) {
      state.owners = []
    },
    [REPORT.SELECT_USED_BY] (state, val) {
      state.usedBy.push(val)
    },
    [REPORT.CLEAR_USED_BY] (state) {
      state.usedBy = []
    },
    [EMPLOYEE_GROUPS.SET_GROUPS](state, employeeGroups) {
      state.employeeGroups = employeeGroups
    },
    [REPORT.SET_RESTRICTION_REPORT](state, restrictionReports) {
      state.restrictionReports = restrictionReports
    },
    [REPORT.REMOVE_OWNER] (state, val) {
      state.owners.splice(val, 1)
    },
    [REPORT.REMOVE_USED_BY] (state, val) {
      state.usedBy.splice(val, 1)
    },
    [REPORT.REMOVE_SINGLE_DESK] (state, val) {
      state.individualDesks.splice(val, 1)
    },
    [REPORT.SET_IS_DOWNLOADING_FILE] (state, value) {
      state.isDownloadingFile = value
    },
    [REPORT.SET_REPORT_TYPE] (state, value) {
      state.reportType = value
    },
    [REPORT.SELECT_UNBOOKED_ENTRANCE_TYPE] (state, val) {
      state.unbookedEntranceType = val
    },
    [REPORT.SET_UNBOOKED_ENTRANCE_REPORT](state, unbookedEntranceReports) {
      state.unbookedEntranceReports = unbookedEntranceReports
    },
  },
  actions: {
    setUnbookedEntranceType: function ({commit}, val) {
      commit(REPORT.SELECT_UNBOOKED_ENTRANCE_TYPE, val)
    },
    setBookingStatus: function ({commit}, val) {
      commit(REPORT.SELECT_BOOKINGSTATUS, val)
    },
    setStartDate: function({commit}, val) {
      commit(REPORT.SET_STARTDATE, val)
    },
    setEndDate: function({commit}, val) {
      commit(REPORT.SET_ENDDATE, val)
    },
    setEmployeeGroup: function ({commit}, val) {
      commit(REPORT.SELECT_EMPLOYEEGROUP, val)
    },
    setDeskGroup: function ({commit}, val) {
      commit(REPORT.SELECT_DESKGROUP, val)
    },
    setLocation: function ({commit}, val) {
      commit(REPORT.SELECT_LOCATION, val)
    },
    setRestaurant: function ({commit}, val) {
      commit(REPORT.SELECT_RESTAURANT, val)
    },
    setItinerary: function ({commit}, val) {
      commit(REPORT.SELECT_ITINERARY, val)
    },
    setRestrictionName: function ({commit}, val) {
      commit(REPORT.SELECT_RESTRICTION_NAME, val)
    },
    setSite: function ({commit}, val) {
      commit(REPORT.SELECT_SITE, val)
    },
    selectSingleDesk ({ commit, }, item) {
      commit(REPORT.SELECT_SINGLE_DESK, item)
    },
    setParking: function ({commit}, val) {
      commit(REPORT.SELECT_PARKING, val)
    },
    setParkings: function ({commit}, val) {
      commit(REPORT.SET_PARKINGS, val)
    },
    selectOwner ({ commit, }, item) {
      let owner = item.email? {email: item.email, name: item.name} : {email: item}
      commit(REPORT.SELECT_OWNER, owner)
    },
    removeOwner ({ commit }, index) {
      commit(REPORT.REMOVE_OWNER, index)
    },
    selectUsedBy ({ commit, }, item) {
      let usedBy = item.email? {email: item.email, name: item.name} : {email: item}
      commit(REPORT.SELECT_USED_BY, usedBy)
    },
    removeUsedBy ({ commit }, index) {
      commit(REPORT.REMOVE_USED_BY, index)
    },
    removeSingleDesk ({ commit }, index) {
      commit(REPORT.REMOVE_SINGLE_DESK, index)
    },
    getUnbookedEntranceReport: async function ({commit, dispatch, state}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        let emails = []
        state.owners.forEach(owner => {
          emails.push(owner.email)
        });
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          employeeGroupIds: state.employeeGroup,
          siteIds: state.site,
          locationIds: state.location,
          emails: emails,
          type: state.unbookedEntranceType
        }
        await reportService.getUnbookedEntranceReport(filters)
          .then((response) => {
            commit(REPORT.SET_UNBOOKED_ENTRANCE_REPORT, response.data)
          })
          .catch(() => {
            commit(REPORT.SET_UNBOOKED_ENTRANCE_REPORT, [])
          });
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    getFilterUnbookedEntranceReport: async function ({commit, dispatch}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        const response =  await reportService.getFilterUnbookedEntranceReport()
        commit(REPORT.SET_REPORT_TYPE, 'unbookedEntrance')
        commit(REPORT.SET_EMPLOYEEGROUPS, response.data.employeeGroups)
        commit(REPORT.SET_DESKGROUPS, response.data.deskGroups)
        commit(REPORT.SET_SITES_WITH_LOCATIONS, response.data.sitesWithLocations)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async downloadUnbookedEntranceReportFile ({dispatch, state}) {
      try {
        dispatch('setIsDownloadingFile', true)
        let emails = []
        state.owners.forEach(owner => {
          emails.push(owner.email)
        });
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          employeeGroupIds: state.employeeGroup,
          siteIds: state.site,
          locationIds: state.location,
          emails: emails,
          type: state.unbookedEntranceType
        }
        let response = await reportService.getUnbookedEntranceReportFile(filters)
        dispatch('setIsDownloadingFile', false)
        let contentType = response.headers['content-type']
        let blob = new Blob([response.data], { type: contentType })
        let contentDisposition = response.headers['content-disposition']
        let fileName = utils.getFileName(contentDisposition)
        utils.handleDownload(blob , fileName)
      } catch (e) {

        dispatch('setIsDownloadingFile', false)
        dispatch('Global/showMessage', 'errorDefault', {root: true})
      }
    },
    getRestrictionReport: async function ({commit, dispatch, state}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        let siteIds = []
        let deskGroupIds = []
        let deskNames = []
        let parkingIds = []

        state.site.forEach(owner => {
          siteIds.push(owner)
        });
        state.deskGroup.forEach(owner => {
          deskGroupIds.push(owner)
        });
        state.parking.forEach(owner => {
          parkingIds.push(owner)
        });
        if (state.individualDesks.length > 0) {
          deskNames = state.individualDesks.map(v => v.desk)
        }
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          siteIds: siteIds,
          deskGroupIds,
          deskNames,
          parkingIds
        }
        if (state.restrictionName) {
          filters.name = state.restrictionName
        }
        if (state.bookingStatus !== null) {
          filters.active = state.bookingStatus === 'active'
        }
        await reportService.getRestrictionReport(filters)
        .then((response) => {
          commit(REPORT.SET_RESTRICTION_REPORT, response.data)
        })
        .catch(() => {
          commit(REPORT.SET_RESTRICTION_REPORT, [])
        });
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    getFilterRestrictionReport: async function ({commit, dispatch}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        const response =  await reportService.getFilterRestrictionReport()
        commit(REPORT.SET_REPORT_TYPE, 'restriction')
        commit(REPORT.SET_PARKINGS, response.data.parkings)
        commit(REPORT.SET_DESKGROUPS, response.data.deskGroups)
        commit(REPORT.SET_SITES_WITH_PARKINGS, response.data.sitesWithParkings)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async downloadFile ({dispatch, state}) {
      try {
        dispatch('setIsDownloadingFile', true)
        let emails = []
        state.owners.forEach(owner => {
          emails.push(owner.email)
        });
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          employeeGroupIds: state.employeeGroup,
          deskGroupIds: state.deskGroup,
          siteIds: state.site,
          locationIds: state.location,
          emails: emails,
          bookingStatus: state.bookingStatus
        }
          let response = await reportService.getReportFile(filters)
          dispatch('setIsDownloadingFile', false)
          let contentType = response.headers['content-type']
          let blob = new Blob([response.data], { type: contentType })
          let contentDisposition = response.headers['content-disposition']
          let fileName = utils.getFileName(contentDisposition)
          utils.handleDownload(blob , fileName)
        } catch (e) {

        dispatch('setIsDownloadingFile', false)
        dispatch('Global/showMessage', 'errorDefault', {root: true})
      }
    },
    async downloadRestrictionReportFile ({dispatch, state}) {
      try {
        dispatch('setIsDownloadingFile', true)
         let reservationBy = []
        let usedBy = []
        state.owners.forEach(owner => {
          reservationBy.push(owner.email)
        });
        state.usedBy.forEach(usr => {
          usedBy.push(usr.email)
        });
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          employeeGroupIds: state.employeeGroup,
          siteIds: state.site,
          locationIds: state.location,
          reservationBy: reservationBy,
          usedBy: usedBy,
          bookingStatus: state.bookingStatus
        }
        let response = await reportService.getRestrictionReportFile(filters)
        dispatch('setIsDownloadingFile', false)
        let contentType = response.headers['content-type']
        let blob = new Blob([response.data], { type: contentType })
        let contentDisposition = response.headers['content-disposition']
        let fileName = utils.getFileName(contentDisposition)
        utils.handleDownload(blob , fileName)
        } catch (e) {

        dispatch('setIsDownloadingFile', false)
        dispatch('Global/showMessage', 'errorDefault', {root: true})
      }
    },
    setIsDownloadingFile ({commit}, value) {
      commit(REPORT.SET_IS_DOWNLOADING_FILE, value)
    },
    clearData: function ({commit}) {
      commit(REPORT.SET_STARTDATE, '')
      commit(REPORT.SET_ENDDATE, '')
      commit(REPORT.SELECT_EMPLOYEEGROUP, [])
      commit(REPORT.SELECT_DESKGROUP, [])
      commit(REPORT.SELECT_LOCATION, [])
      commit(REPORT.SELECT_RESTAURANT, [])
      commit(REPORT.SELECT_ITINERARY, [])
      commit(REPORT.SELECT_SITE, [])
      commit(REPORT.SET_SITES_WITH_LOCATIONS, null)
      commit(REPORT.SET_SITES_WITH_RESTAURANTS, null)
      commit(REPORT.SET_SITES_WITH_PARKINGS, null)
      commit(REPORT.SELECT_BOOKINGSTATUS, null)
      commit(REPORT.CLEAR_OWNER)
      commit(REPORT.CLEAR_USED_BY)
      commit(REPORT.SET_REPORT_TYPE, '')
      commit(REPORT.SET_UNBOOKED_ENTRANCE_REPORT, [])
      commit(REPORT.SELECT_UNBOOKED_ENTRANCE_TYPE, null)
    }
  }
}
